(() => {
  const kwikPassTriggers = [...document.querySelectorAll('[data-kwikpass-login]')];
  const findKwikPassFrame = () => document.querySelector('#iframe-kp, iframe[src*="/kwikpass/"], iframe[src*="kwikpass.html"]');
  const revealKwikPass = () => {
    const frame = findKwikPassFrame();
    if (!frame) return false;
    frame.classList.remove('hidden');
    frame.removeAttribute('hidden');
    frame.setAttribute('aria-hidden', 'false');
    frame.style.removeProperty('display');
    document.body.classList.add('kwikpass-open');
    window.setTimeout(() => frame.focus(), 0);
    return true;
  };

  kwikPassTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (revealKwikPass()) return;

      trigger.classList.add('is-loading');
      trigger.setAttribute('aria-busy', 'true');
      const fallback = trigger.dataset.loginFallback || trigger.getAttribute('href') || '/account/login';
      let settled = false;
      let fallbackTimer;
      const observer = new MutationObserver(() => {
        if (revealKwikPass()) finish(true);
      });
      const finish = (opened) => {
        if (settled) return;
        settled = true;
        observer.disconnect();
        window.clearTimeout(fallbackTimer);
        trigger.classList.remove('is-loading');
        trigger.removeAttribute('aria-busy');
        if (!opened) window.location.assign(fallback);
      };
      observer.observe(document.documentElement, { childList: true, subtree: true });
      fallbackTimer = window.setTimeout(() => finish(revealKwikPass()), 2500);
    });
  });

  document.querySelectorAll('[data-announcement-rotation]').forEach((bar) => {
    const items = [...bar.querySelectorAll('[data-announcement-item]')];
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const interval = Math.max(3000, Number(bar.dataset.interval || 5000));
    let activeIndex = 0;
    window.setInterval(() => {
      if (document.hidden) return;
      activeIndex = (activeIndex + 1) % items.length;
      items.forEach((item, index) => {
        const active = index === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
      });
    }, interval);
  });

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const drawerOverlay = document.querySelector('[data-drawer-overlay]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const searchToggles = [...document.querySelectorAll('[data-search-toggle]')];

  const syncDrawerState = () => {
    const menuOpen = mobileMenu?.hasAttribute('data-open');
    const searchOpen = searchPanel?.hasAttribute('data-open');
    const anyOpen = Boolean(menuOpen || searchOpen);
    drawerOverlay?.toggleAttribute('data-open', anyOpen);
    document.body.classList.toggle('menu-open', anyOpen);
    menuToggle?.setAttribute('aria-expanded', String(Boolean(menuOpen)));
    searchToggles.forEach((button) => button.setAttribute('aria-expanded', String(Boolean(searchOpen))));
    mobileMenu?.setAttribute('aria-hidden', String(!menuOpen));
    searchPanel?.setAttribute('aria-hidden', String(!searchOpen));
    if (mobileMenu) mobileMenu.inert = !menuOpen;
    if (searchPanel) searchPanel.inert = !searchOpen;
  };

  const closeMenu = () => {
    const restoreFocus = mobileMenu?.contains(document.activeElement);
    mobileMenu?.removeAttribute('data-open');
    syncDrawerState();
    if (restoreFocus) menuToggle?.focus({ preventScroll: true });
  };
  const closeSearch = () => {
    const restoreFocus = searchPanel?.contains(document.activeElement);
    searchPanel?.removeAttribute('data-open');
    syncDrawerState();
    if (restoreFocus) searchToggles[0]?.focus({ preventScroll: true });
  };
  const openMenu = () => {
    closeSearch();
    mobileMenu?.setAttribute('data-open', '');
    syncDrawerState();
    mobileMenu?.focus({ preventScroll: true });
  };
  const openSearch = () => {
    closeMenu();
    searchPanel?.setAttribute('data-open', '');
    syncDrawerState();
    window.setTimeout(() => searchPanel?.querySelector('[data-predictive-input]')?.focus(), 180);
  };

  menuToggle?.addEventListener('click', () => mobileMenu?.hasAttribute('data-open') ? closeMenu() : openMenu());
  syncDrawerState();
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));
  searchToggles.forEach((button) => button.addEventListener('click', openSearch));
  document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', closeSearch));
  drawerOverlay?.addEventListener('click', () => { closeMenu(); closeSearch(); });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (searchPanel?.hasAttribute('data-open')) closeSearch();
    else if (mobileMenu?.hasAttribute('data-open')) closeMenu();
  });

  document.querySelectorAll('.mobile-nav__level--one').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      details.parentElement?.querySelectorAll(':scope > .mobile-nav__level--one[open]').forEach((sibling) => {
        if (sibling !== details) sibling.open = false;
      });
    });
  });
  document.querySelectorAll('.mobile-nav__level--two').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      details.parentElement?.querySelectorAll(':scope > .mobile-nav__level--two[open]').forEach((sibling) => {
        if (sibling !== details) sibling.open = false;
      });
    });
  });

  if (searchPanel) {
    const input = searchPanel.querySelector('[data-predictive-input]');
    const results = searchPanel.querySelector('[data-predictive-results]');
    const status = searchPanel.querySelector('[data-predictive-status]');
    const allResultsLink = searchPanel.querySelector('[data-search-all]');
    const searchForm = searchPanel.querySelector('[data-predictive-form]');
    const predictiveUrl = searchPanel.dataset.predictiveUrl;
    let predictiveTimer;
    let predictiveRequest;
    let predictiveVersion = 0;
    const predictiveCache = new Map();

    const resetPredictiveSearch = () => {
      if (results) results.innerHTML = '';
      if (status) status.textContent = 'Start typing to see matching fishing gear.';
      if (allResultsLink) {
        allResultsLink.href = searchForm?.action || '/search';
        allResultsLink.firstChild.textContent = 'View all products ';
      }
    };

    const loadPredictiveSearch = async (term) => {
      if (!predictiveUrl || !results) return;
      const version = ++predictiveVersion;
      predictiveRequest?.abort();
      predictiveRequest = new AbortController();
      const url = new URL(predictiveUrl, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      searchPanel.setAttribute('data-loading', '');
      if (status) status.textContent = `Searching for “${term}”…`;
      if (allResultsLink) {
        const searchUrl = new URL(searchForm?.action || '/search', window.location.origin);
        searchUrl.searchParams.set('q', term);
        searchUrl.searchParams.set('type', 'product');
        allResultsLink.href = `${searchUrl.pathname}${searchUrl.search}`;
        allResultsLink.firstChild.textContent = `Search for “${term}” `;
      }
      try {
        let markup = predictiveCache.get(term);
        if (!markup) {
        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: predictiveRequest.signal
        });
        if (!response.ok) throw new Error('Search is temporarily unavailable.');
        markup = await response.text();
        if (predictiveCache.size >= 12) predictiveCache.delete(predictiveCache.keys().next().value);
        predictiveCache.set(term, markup);
        }
        if (version !== predictiveVersion) return;
        const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
        const content = documentFragment.querySelector('[data-predictive-search-results]');
        results.innerHTML = content ? content.outerHTML : '';
        const count = Number(content?.dataset.resultCount || 0);
        if (status) status.textContent = count > 0 ? `${count} matching products` : `No products found for “${term}”`;
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.innerHTML = '<div class="predictive-search__empty"><strong>Search could not load.</strong><span>Press enter to view the full search page.</span></div>';
        if (status) status.textContent = 'Search results could not load.';
      } finally {
        if (version === predictiveVersion) searchPanel.removeAttribute('data-loading');
      }
    };

    input?.addEventListener('input', () => {
      window.clearTimeout(predictiveTimer);
      predictiveVersion++;
      predictiveRequest?.abort();
      const term = input.value.trim();
      if (term.length < 2) {
        predictiveRequest?.abort();
        searchPanel.removeAttribute('data-loading');
        resetPredictiveSearch();
        return;
      }
      predictiveTimer = window.setTimeout(() => loadPredictiveSearch(term), 220);
    });
    resetPredictiveSearch();
  }

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const change = button.dataset.action === 'increase' ? 1 : -1;
        input.value = Math.max(1, Number(input.value || 1) + change);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-slider-dot]')];
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const shouldAutoplay = slider.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Math.max(4000, Number(slider.dataset.interval || 6000));
    let activeIndex = 0;
    let timer;
    let visible = true;
    let paused = false;
    const pauseButton = slider.querySelector('[data-slider-pause]');
    const hydrateSlide = (index) => {
      slides[(index + slides.length) % slides.length]?.querySelectorAll('[data-hero-src]').forEach(image => {
        image.src = image.dataset.heroSrc;
        image.removeAttribute('data-hero-src');
      });
    };

    const showSlide = (requestedIndex) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;
      hydrateSlide(activeIndex);
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (shouldAutoplay && slides.length > 1 && visible && !paused && !document.hidden && !slider.contains(document.activeElement)) timer = window.setInterval(() => { showSlide(activeIndex + 1); hydrateSlide(activeIndex + 1); }, interval);
    };

    previous?.addEventListener('click', () => { showSlide(activeIndex - 1); startAutoplay(); });
    next?.addEventListener('click', () => { showSlide(activeIndex + 1); startAutoplay(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.sliderDot)); startAutoplay(); }));
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);
    pauseButton?.addEventListener('click', () => {
      paused = !paused;
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.textContent = paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel;
      startAutoplay();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;startAutoplay();}, {threshold:0.05});
      observer.observe(slider);
    }
    document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
    showSlide(0);
    if (shouldAutoplay) window.setTimeout(() => {if (visible && !document.hidden) hydrateSlide(1);}, 1800);
    startAutoplay();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const stage = gallery.querySelector('[data-gallery-stage]');
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
    const variantSelect = gallery.closest('section')?.querySelector('[data-main-variant]');
    let activeIndex = 0;
    let touchStartX = 0;
    let suppressOpen = false;

    if (slides.length === 0) return;

    const updateDialogImage = () => {
      const opener = slides[activeIndex]?.querySelector('[data-gallery-open]');
      if (!opener || !dialogImage) return;
      dialogImage.src = opener.dataset.zoomSrc || '';
      dialogImage.alt = opener.dataset.zoomAlt || '';
    };

    const showImage = (requestedIndex, scrollThumbnail = true) => {
      activeIndex = Math.min(Math.max(requestedIndex, 0), slides.length - 1);
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      thumbnails.forEach((thumbnail, index) => {
        const active = index === activeIndex;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', String(active));
      });
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
      if (current) current.textContent = String(activeIndex + 1);
      if (scrollThumbnail) thumbnails[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (dialog?.open) updateDialogImage();
    };

    const selectVariantForMedia = (mediaId) => {
      if (!mediaId || !variantSelect || variantSelect.tagName !== 'SELECT') return;
      const matchingOption = [...variantSelect.options].find((option) => (
        option.dataset.imageId === String(mediaId) && !option.disabled
      ));
      if (!matchingOption || variantSelect.value === matchingOption.value) return;
      variantSelect.value = matchingOption.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    };

    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
      showImage(Number(thumbnail.dataset.galleryThumb));
      selectVariantForMedia(thumbnail.dataset.galleryMediaId);
    }));
    previous?.addEventListener('click', () => showImage(activeIndex - 1));
    next?.addEventListener('click', () => showImage(activeIndex + 1));

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showImage(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    stage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
      suppressOpen = false;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) < 45) return;
      suppressOpen = true;
      showImage(activeIndex + (distance < 0 ? 1 : -1));
      window.setTimeout(() => { suppressOpen = false; }, 350);
    }, { passive: true });

    gallery.querySelectorAll('[data-gallery-open]').forEach((opener) => {
      opener.addEventListener('click', () => {
        if (suppressOpen || !dialog?.showModal) return;
        updateDialogImage();
        dialog.showModal();
        document.body.classList.add('gallery-open');
      });
    });

    const closeDialog = () => {
      if (!dialog?.open) return;
      dialog.close();
      document.body.classList.remove('gallery-open');
    };
    gallery.querySelector('[data-gallery-close]')?.addEventListener('click', closeDialog);
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    dialog?.addEventListener('close', () => document.body.classList.remove('gallery-open'));
    variantSelect?.addEventListener('change', () => {
      const mediaId = variantSelect.selectedOptions?.[0]?.dataset.imageId;
      if (!mediaId) return;
      const matchingIndex = slides.findIndex((slide) => slide.dataset.galleryMediaId === mediaId);
      if (matchingIndex >= 0) showImage(matchingIndex);
    });
    showImage(0, false);
  });

  document.querySelectorAll('[data-variant-swatches]').forEach((swatches) => {
    const form = swatches.closest('form');
    const select = form?.querySelector('[data-main-variant]');
    const submit = form?.querySelector('[data-product-submit]');
    const sku = form?.closest('.product-info')?.querySelector('[data-product-sku]');
    const skuValue = sku?.querySelector('[data-product-sku-value]');
    if (!select || select.tagName !== 'SELECT') return;

    const buttons = [...swatches.querySelectorAll('[data-variant-choice]')];
    const syncVariant = () => {
      const option = select.selectedOptions?.[0];
      if (!option) return;
      buttons.forEach((button) => {
        const selected = button.dataset.variantId === option.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      if (submit) submit.disabled = option.disabled;
      if (sku && skuValue) {
        skuValue.textContent = option.dataset.sku || '';
        sku.hidden = !option.dataset.sku;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    };

    const selectVariant = (variantId) => {
      const option = [...select.options].find((item) => item.value === String(variantId));
      if (!option || option.disabled) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    select.addEventListener('change', syncVariant);
    buttons.forEach((button) => button.addEventListener('click', () => selectVariant(button.dataset.variantId)));
  });

  const formatMoney = (cents, currency = 'INR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `₹${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  document.querySelectorAll('.product-info').forEach((productInfo) => {
    const form = productInfo.querySelector('.product-form');
    const variant = form?.querySelector('[data-main-variant]');
    const price = productInfo.querySelector('[data-product-current-price]');
    const comparePrice = productInfo.querySelector('[data-product-compare-price]');
    const availability = productInfo.querySelector('[data-product-availability]');
    const stickyBar = productInfo.closest('section')?.querySelector('[data-mobile-buybar]');
    const stickyVariant = stickyBar?.querySelector('[data-sticky-variant]');
    const stickyPrice = stickyBar?.querySelector('[data-sticky-price]');
    const stickyButton = stickyBar?.querySelector('[data-sticky-add]');
    const mainSubmit = form?.querySelector('[data-product-submit]');

    const syncProductInfo = () => {
      if (!variant || variant.tagName !== 'SELECT') return;
      const option = variant.selectedOptions?.[0];
      if (!option) return;
      if (price) price.textContent = option.dataset.priceFormatted || formatMoney(option.dataset.price, 'INR');
      const compare = Number(option.dataset.compareAt || 0);
      if (comparePrice) {
        comparePrice.textContent = compare > Number(option.dataset.price || 0) ? (option.dataset.compareFormatted || formatMoney(compare, 'INR')) : '';
        comparePrice.hidden = compare <= Number(option.dataset.price || 0);
      }
      const available = option.dataset.available === 'true' && !option.disabled;
      if (availability) {
        availability.innerHTML = available ? '<span aria-hidden="true">●</span> In stock and ready to order' : 'Sold out';
        availability.classList.toggle('is-sold-out', !available);
      }
      if (stickyPrice) stickyPrice.textContent = option.dataset.priceFormatted || formatMoney(option.dataset.price, 'INR');
      if (stickyVariant) stickyVariant.childNodes[0].textContent = `${option.dataset.variantTitle || option.textContent.split(' — ')[0]} • `;
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
    };

    variant?.addEventListener('change', syncProductInfo);
    stickyButton?.addEventListener('click', () => {
      if (!form || !mainSubmit || stickyButton.disabled) return;
      if (form.requestSubmit) form.requestSubmit(mainSubmit);
      else mainSubmit.click();
    });
    syncProductInfo();
  });

  const initProductUpsell = (form) => {
    if (!form || form.dataset.upsellReady === 'true') return;
    const addonContainer = form.querySelector('[data-product-addons-content]');
    if (!addonContainer) return;
    form.dataset.upsellReady = 'true';

    const submitButton = form.querySelector('[data-product-submit]');
    const submitLabel = form.querySelector('[data-product-submit-label]');
    const errorMessage = form.querySelector('[data-product-form-error]');
    const mainVariant = form.querySelector('[data-main-variant]');
    const quantity = form.querySelector('[name="quantity"]');
    const currency = form.querySelector('[data-product-addons]')?.dataset.currency || 'INR';
    const cards = [...form.querySelectorAll('[data-addon-card]')];

    const currentMainPrice = () => {
      if (mainVariant?.tagName === 'SELECT') return Number(mainVariant.selectedOptions[0]?.dataset.price || 0);
      return Number(mainVariant?.dataset.price || 0);
    };

    const updateSummary = () => {
      const selected = cards.filter((card) => card.querySelector('[data-addon-checkbox]')?.checked);
      cards.forEach((card) => card.classList.toggle('is-selected', card.querySelector('[data-addon-checkbox]')?.checked));
      if (!submitLabel || selected.length === 0) {
        if (submitLabel) submitLabel.textContent = 'Add to cart';
        return;
      }
      const mainQuantity = Math.max(1, Number(quantity?.value || 1));
      const addonsTotal = selected.reduce((total, card) => total + Number(card.querySelector('[data-addon-checkbox]')?.dataset.price || 0), 0);
      const total = (currentMainPrice() * mainQuantity) + addonsTotal;
      const itemCount = mainQuantity + selected.length;
      submitLabel.textContent = `Add ${itemCount} items • ${formatMoney(total, currency)}`;
    };

    cards.forEach((card) => {
      const checkbox = card.querySelector('[data-addon-checkbox]');
      const variantSelect = card.querySelector('[data-addon-variant]');
      checkbox?.addEventListener('change', updateSummary);
      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (checkbox && option) {
          checkbox.value = option.value;
          checkbox.dataset.price = option.dataset.price || '0';
        }
        updateSummary();
      });
    });
    mainVariant?.addEventListener('change', updateSummary);
    quantity?.addEventListener('input', updateSummary);

    form.addEventListener('submit', async (event) => {
      const selected = cards.map((card) => card.querySelector('[data-addon-checkbox]')).filter((checkbox) => checkbox?.checked);
      if (selected.length === 0) return;
      event.preventDefault();

      const variantId = mainVariant?.value;
      if (!variantId || !submitButton) return;
      const itemQuantities = new Map([[String(variantId), Math.max(1, Number(quantity?.value || 1))]]);
      selected.forEach((checkbox) => {
        const id = String(checkbox.value);
        itemQuantities.set(id, (itemQuantities.get(id) || 0) + 1);
      });
      const items = [...itemQuantities].map(([id, itemQuantity]) => ({ id: Number(id), quantity: itemQuantity }));
      const root = window.Shopify?.routes?.root || '/';

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      if (submitLabel) submitLabel.textContent = 'Adding your items…';
      if (errorMessage) errorMessage.hidden = true;

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Some items could not be added.');
        if (window.FishingLureCart) await window.FishingLureCart.refresh({ open: true, message: 'Added to your tackle box.' });
        else window.location.assign(`${root}cart`);
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        updateSummary();
      } catch (error) {
        if (errorMessage) {
          errorMessage.textContent = error.message || 'Something went wrong. Please try again.';
          errorMessage.hidden = false;
        }
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        updateSummary();
      }
    });

    updateSummary();
  };

  document.querySelectorAll('[data-product-addons][data-url]').forEach(async (container) => {
    if (container.querySelector('[data-product-addons-content]')) {
      initProductUpsell(container.closest('form'));
      return;
    }
    try {
      const response = await fetch(container.dataset.url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = documentFragment.querySelector('[data-product-addons-content]');
      if (!content || !content.querySelector('[data-addon-card]')) return;
      container.innerHTML = content.outerHTML;
      initProductUpsell(container.closest('form'));
    } catch (error) {
      // The standard product form remains fully functional when recommendations are unavailable.
    }
  });

  document.querySelectorAll('[data-product-recommendations][data-url]').forEach(async (container) => {
    if (!container.hidden) return;
    try {
      const response = await fetch(container.dataset.url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const recommendations = documentFragment.querySelector('[data-product-recommendations]');
      if (!recommendations || recommendations.hidden || !recommendations.querySelector('.product-card')) return;
      container.innerHTML = recommendations.innerHTML;
      container.hidden = false;
    } catch (error) {
      // Keep an empty recommendation section hidden.
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-card-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-card-submit]');
    const label = form.querySelector('[data-card-submit-label]');
    const message = form.querySelector('[data-card-message]');
    if (!button || button.disabled) return;
    const root = window.Shopify?.routes?.root || '/';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (message) message.hidden = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
      if (!window.FishingLureCart) {
      const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      const cart = await cartResponse.json();
      document.querySelectorAll('.icon-link--cart').forEach((cartLink) => {
        let count = cartLink.querySelector('.cart-count');
        if (!count) {
          count = document.createElement('span');
          count.className = 'cart-count';
          cartLink.append(count);
        }
        count.textContent = String(cart.item_count || 0);
      });
      }
      if (label) label.textContent = '✓ Added';
      if (message) { message.textContent = 'Added to your cart.'; message.hidden = false; }
      if (window.FishingLureCart) await window.FishingLureCart.refresh({ open: true, message: 'Added to your tackle box.' });
      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = '+ Add';
      }, 1500);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = 'Try again';
      if (message) { message.textContent = error.message || 'Unable to add this item.'; message.hidden = false; }
    }
  });

  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterOverlay = document.querySelector('[data-filter-overlay]');
  const closeFilters = () => {
    filterPanel?.removeAttribute('data-open');
    filterOverlay?.removeAttribute('data-open');
    document.body.classList.remove('filters-open');
    document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
  };
  document.querySelector('[data-filter-open]')?.addEventListener('click', () => {
    filterPanel?.setAttribute('data-open', '');
    filterOverlay?.setAttribute('data-open', '');
    document.body.classList.add('filters-open');
    document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'true');
  });
  document.querySelector('[data-filter-close]')?.addEventListener('click', closeFilters);
  filterOverlay?.addEventListener('click', closeFilters);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFilters(); });
})();
